export default __webpack_public_path__ + "static/media/AdPirates_00.d483e38e.png";